"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceSetString = function (mainUrl, srcSet) {
    var withWidths = srcSet.map(function (set) { return set.url + " " + set.width; }).reverse();
    return withWidths.concat([mainUrl]).join(",");
};
